export default "__VITE_ASSET__DjfLEQe1__"